import { useTranslation } from "react-i18next";
import { DialogControl } from "~/hooks/use-dialog";
import { Modal } from "~/components/modal/modal";

interface OrganisationAdminRequiredModalProps {
  control: DialogControl<string>;
}

export const OrganisationAdminRequiredModal = ({
  control,
}: OrganisationAdminRequiredModalProps) => {
  const { t } = useTranslation(["settings"]);

  return (
    <Modal
      id={control.id}
      title={t("settings:organisation.members.role.admin-required.title")}
      description={t(
        "settings:organisation.members.role.admin-required.description",
      )}
      confirmLabel={t(
        "settings:organisation.members.role.admin-required.confirm",
      )}
      cancelLabel={t(
        "settings:organisation.members.role.admin-required.cancel",
      )}
      open={control.isOpen}
      onOpenChange={control.onOpenChange}
      variant="warning"
      mainIconName="octagon-alert"
      onConfirm={control.close}
    />
  );
};
